require('../../../lib/js/angularmodule/JV.Core.Directives');
require('../../../lib/angular-gridster/angular-gridster.min.js');
require('../../jhire/services/jv.Reqs');

//DB:TODO Including timezone throws an error on browserify
//require('../../../lib/moment/moment.js');
//require('../../../lib/moment/timezone.js');

require('../../../lib/select2/select2-3.4.5/select2.min.js');
require('../../common/polyfills.js');
require('../../common/directives/jv.AjaxSelect.js');
require('../../common/jv.Filters.js');
require('./jv.Dashboard.Factory');
require('./jv.Dashboard.Ajax.Service');
require('./jv.Dashboard.Directive');
require('./jv.Viewfields.Directive');
require('./jv.Dashboard.Config');
require('./jv.Dashboard.ActionsMenu.Controller');
require('./jv.Dashboard.Kpi.Controller');
require('./jv.Dashboard.Controller');
require('./jv.Dashboard.MyOpenJobs.Controller');
require('./jv.Dashboard.Upcoming.Interviews.Controller');
require('./jv.Dashboard.Pending.Approvals.Controller');
require('./jv.Dashboard.My.Pending.Approvals.Controller');
require('./jv.Dashboard.Billboard.Controller');
require('./jv.Dashboard.Todo.Tasks.Controller');
require('./jv.Dashboard.My.Referrals.Controller');
require('./jv.Dashboard.My.Pending.Evaluations.Controller');
require('./jv.Dashboard.Analytics.TimeSeries.Controller');
require('./jv.Dashboard.Analytics.Req.BarChart.Controller');
require('./jv.Dashboard.Analytics.Controller');
require('./jv.Dashboard.My.Open.Jobs.Pending.Evaluations.Controller');
require('./jv.Dashboard.AllOpenJobs.Controller');
require('./jv.Dashboard.ReportBookmark.Controller');
require('./jv.Dashboard.Campaigns.Controller.js');
require('./jv.Dashboard.My.Time.To.Fill.Controller.js');
require('./jv.Dashboard.Canvas.Application.Controller');
require('./jv.gridster.onload.directive');
require('../../common/directives/jv.Datepicker');
require('../../common/directives/jv.Common.Directives.Focus');
require('../../common/directives/jv.Select2');
require('../../common/directives/jv.Common.Directives.trunk8');
require('../../common/directives/jv.Common.Directives.WeekCalendar');
require('../../common/directives/jv.Common.Directives.PrettyTime');
require('../../common/directives/jv.common.timeseries.directive');
require('../../common/directives/jv.common.barchart.directive');
require('../../common/directives/jv.common.chart.directive');
require('../../common/jv.Jobvite.Urls');
require('../../common/jv.TemplateLoader');
require('../../common/jv.Modal');
require('../../common/jv.MessageBar');
require('../../common/jv.Loading.webpack');
require('../../jhire/controllers/requisitions/jv.ApprovalDir');
require('./jv.Dashboard.WidgetList.Controller');
require('../../common/jv.i18n');
require('../../candidates/search/jv.search.url-redirect.service.webpack');

angular.module('jv.Dashboard.app', [
    'ngRoute',
    'jv',
   'jv.Dashboard.Factory',
   'jv.Dashboard.Ajax.Service',
   'jv.Dashboard.Directive',
   'jv.Viewfields.Directive',
   'jv.Dashboard.Config',
   'jv.Dashboard.ActionsMenu.Controller',
   'jv.Dashboard.Kpi.Controller',
   'jv.dashboard.controller',
   'jv.Dashboard.MyOpenJobs.Controller',
   'jv.Dashboard.Upcoming.Interviews.Controller',
   'jv.Dashboard.Pending.Approvals.Controller',
   'jv.Dashboard.My.Pending.Approvals.Controller',
   'jv.Dashboard.Billboard.Controller',
   'jv.Dashboard.Todo.Tasks.Controller',
   'jv.Dashboard.My.Referrals.Controller',
   'jv.Dashboard.My.Pending.Evaluations.Controller',
   'jv.Dashboard.Analytics.TimeSeries.Controller',
   'jv.Dashboard.Analytics.Req.BarChart.Controller',
   'jv.Dashboard.Analytics.Controller',
   'jv.Dashboard.My.Open.Jobs.Pending.Evaluations.Controller',
   'jv.Dashboard.AllOpenJobs.Controller',
   'jv.Dashboard.ReportBookmark.Controller',
   'jv.Dashboard.Campaigns.Controller',
   'jv.Dashboard.My.Time.To.Fill.Controller',
   'jv.Dashboard.Canvas.Application.Controller',
   'jv.Gridster.Onload.Directive',
   'jv.Common.Directives.Datepicker',
   'jv.Common.Directives.Focus',
   'jv.Common.Directives.Select2',
   'jv.Common.Directives.trunk8',
   'jv.Common.Directives.WeekCalendar',
   'jv.Common.Directives.jvPrettyTime',
   'jv.common.timeseries.directive',
   'jv.common.barchart.directive',
   'jv.common.chart.directive',
   'jv.Common.Jobvite.Urls',
   'jv.Common.TemplateLoader',
   'jv.Common.Modal',
   'jv.Common.MessageBar',
   'jv.Common.Loading',
   'jv.ApprovalDir',
   'jv.Dashboard.WidgetList.Controller',
   'jv.Common.i18n',
   'jv.search.url-redirect.service',
    'JV.Core.Directives',
    'gridster',
    'jv.Common.AjaxSelect',
    'jv.Common.Filters',
    'jv.services',
    'ngSanitize',
    'chart.js'
]);
